module.exports = __webpack_public_path__ + "img/hk-1.c9fd9e48.jpg";